<template>
  <div class="pagination">
    <a href="#" class="bt_prev" v-if="visiblePrev" @click.prevent="changePage(startPage - 1)">
      <v-icon clsName="icon_prev" />
      <span class="access_hidden">이전 페이지</span>
    </a>
    <span class="pagination_num">
      <template v-for="page in pageList">
        <strong v-if="page == offset"
          ><span>{{ page }}</span></strong
        >
        <a href="#" v-else @click.prevent="changePage(page)"
          ><span>{{ page }}</span></a
        >
      </template>
    </span>
    <a href="#" class="bt_next" v-if="visibleNext" @click.prevent="changePage(startPage + pageSize)">
      <v-icon clsName="icon_next" />
      <span class="access_hidden">다음 페이지</span>
    </a>
  </div>
</template>

<script>
import VIcon from '@/components/atoms/VIcon';
import VButton from '@/components/atoms/VButton';

export default {
  model: {
    event: 'custom-change',
  },
  data() {
    return {
      totalPageCnt: 0,
      currentPage: 0,
      startPage: 0,
    };
  },
  components: {
    VIcon,
  },
  props: {
    totalItemCnt: {
      type: Number,
      default: 711,
    },
    listItemSize: {
      type: Number,
      default: 30,
    },
    offset: {
      type: Number,
      default: 90,
    },
    pageSize: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    pageList() {
      let result = [];
      this.totalPageCnt = Math.ceil(this.totalItemCnt / this.pageSize);
      this.startPage = Math.floor((this.offset - 1) / this.listItemSize) * this.listItemSize + 1;

      for (let i = this.startPage; i < this.startPage + this.listItemSize; i++) {
        result.push(i);

        if (i * this.pageSize >= this.totalItemCnt) {
          break;
        }
      }
      return result;
    },
    visiblePrev() {
      return this.startPage > this.listItemSize;
    },
    visibleNext() {
      return this.startPage + this.listItemSize < this.totalPageCnt;
    },
  },
  methods: {
    changePage(page) {
      this.$emit('custom-change', page);
    },
  },
};
</script>
